import { useEffect, useState } from 'react';

/* eslint-disable @typescript-eslint/no-magic-numbers */
const defaultLoadingRanges = [
  {
    range: [0, 20],
    time: 500,
  },
  {
    range: [21, 63],
    time: 1500,
  },
  {
    range: [64, 100],
    time: 5000,
  },
];
/* eslint-enable @typescript-eslint/no-magic-numbers */

const MAX_PERCENTS = 100;

export const useLoadingProgress = ({
  onDone,
  loadingRanges,
}: {
  onDone: () => void;
  loadingRanges?: { range: [number, number]; time: number }[];
}) => {
  const lRange = loadingRanges || defaultLoadingRanges;

  const [progress, setProgress] = useState({ percents: 0, label: '' });
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (progress.percents === MAX_PERCENTS) {
      return;
    }

    const stepInterval = lRange[step].time;
    let percents = progress.percents;

    const intervalId = setInterval(() => {
      percents = Math.floor(Math.min(percents + 1, MAX_PERCENTS));

      if (percents === MAX_PERCENTS) {
        clearInterval(intervalId);

        if (onDone) {
          onDone();
        }
      }

      if (percents === lRange[step].range[1]) {
        setStep((step + 1) % lRange.length);
      }

      setProgress({
        percents,
        label: `${percents}%`,
      });
    }, stepInterval / (lRange[step].range[1] - lRange[step].range[0]));

    return () => {
      clearInterval(intervalId);
    };
  }, [lRange, onDone, progress.percents, step]);

  return { progress };
};
